import { cn } from '@/lib/utils'

interface ColorSwatchProps {
  color?: string
  className?: string
}

export function ColorSwatch({ color, className }: ColorSwatchProps) {
  if (!color) return null

  return (
    <span
      className={cn('inline-block h-4 w-4 shrink-0 rounded-full border border-neutral-200', className)}
      style={{ backgroundColor: color }}
    />
  )
}
